(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/adobe-target-payload-handler/assets/javascripts/click-payload.js') >= 0) return;  svs.modules.push('/components/components/adobe-target-payload-handler/assets/javascripts/click-payload.js');
"use strict";

var clickedElements = new Set();
var getDataAttributeValue = svs.components.adobeTargetPayloadHandler.helpers.getDataAttributeValue;
var CRM_MBOX = 'crmMbox';
var CRM_MBOX_CLICK_PE = 'crmAnalyticsClickPayloadPe';
var CRM_MBOX_CLICK_TNTA = 'crmAnalyticsClickPayloadTnta';
var getValidClickNodes = function getValidClickNodes(element) {
  if (Object.prototype.hasOwnProperty.call(element.dataset, CRM_MBOX)) {
    return false;
  }
  var nodeName = element.nodeName,
    parentElement = element.parentElement;
  if (nodeName === 'BUTTON' || nodeName === 'A') {
    return true;
  } else if (parentElement) {
    return getValidClickNodes(parentElement);
  }
  return false;
};
var sendClickPayload = function sendClickPayload(clickEvent, widgetElement) {
  if (!clickedElements.has(widgetElement)) {
    if (getValidClickNodes(clickEvent.target)) {
      clickedElements.add(widgetElement);
      var pe = getDataAttributeValue(widgetElement, CRM_MBOX_CLICK_PE);
      var tnta = getDataAttributeValue(widgetElement, CRM_MBOX_CLICK_TNTA);
      if (pe && tnta) {
        svs.components.analytics.sendTargetPayload({
          pe: pe,
          tnta: tnta
        });
      }
    }
  }
};

var childSendClickPayload = function childSendClickPayload(clickEvent) {
  var element = clickEvent.currentTarget;
  if (element.nodeName === 'BUTTON' && $(element).closest('a')) {
    return;
  }
  var widgetElement = $(element).closest('[data-crm-mbox]');
  if (!clickedElements.has(element)) {
    if (getValidClickNodes(element)) {
      clickedElements.add(element);
      var pe = getDataAttributeValue(widgetElement[0], CRM_MBOX_CLICK_PE);
      var tnta = getDataAttributeValue(widgetElement[0], CRM_MBOX_CLICK_TNTA);
      var mbox = getDataAttributeValue(widgetElement[0], CRM_MBOX);
      if (pe && tnta) {
        svs.components.analytics.sendTargetPayload({
          pe: pe,
          tnta: tnta,
          mbox: mbox
        }, function () {});
      }
    }
  }
};

var selfSendClickPayload = function selfSendClickPayload(event) {
  var element = event.currentTarget;
  var nodeName = element.nodeName;
  if (!clickedElements.has(element)) {
    if (Object.prototype.hasOwnProperty.call(element.dataset, CRM_MBOX) && nodeName === 'BUTTON' || nodeName === 'A') {
      clickedElements.add(element);
      var pe = getDataAttributeValue(element, CRM_MBOX_CLICK_PE);
      var tnta = getDataAttributeValue(element, CRM_MBOX_CLICK_TNTA);
      var mbox = getDataAttributeValue(element, CRM_MBOX);
      if (pe && tnta) {
        svs.components.analytics.sendTargetPayload({
          pe: pe,
          tnta: tnta,
          mbox: mbox
        }, function () {});
      }
    }
  }
};
var setupClickInMbox = function setupClickInMbox(element) {
  element.addEventListener('click', function (event) {
    sendClickPayload(event, element);
  });
};
svs.components.adobeTargetPayloadHandler.setupClickInMbox = setupClickInMbox;
svs.components.adobeTargetPayloadHandler.selfSendClickPayload = selfSendClickPayload;
svs.components.adobeTargetPayloadHandler.childSendClickPayload = childSendClickPayload;

 })(window);